module.exports = __webpack_public_path__ + "static/img/4.dff3d54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/4.png
// module id = DqdP
// module chunks = 0